var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotificationSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3H11V8H13V3Z",
    fill: "#565A5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69411 11.6314C7.87147 10.6855 8.69742 10 9.65985 10H14.3401C15.3026 10 16.1285 10.6855 16.3059 11.6314L16.5936 13.1657C13.9584 13.7987 12 16.1706 12 19C12 19.3407 12.0284 19.6748 12.083 20H5V18H6.5L7.69411 11.6314Z",
    fill: "#565A5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15V13H1V15H6Z",
    fill: "#565A5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9L7.08579 10.4142L3.55025 6.87868L4.96447 5.46447L8.5 9Z",
    fill: "#565A5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9142 10.4142L15.5 9L19.0355 5.46447L20.4497 6.87868L16.9142 10.4142Z",
    fill: "#565A5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.41 17.1974L16.875 18.6624L20.59 14.9575C20.98 14.5675 21.61 14.5675 22 14.9575C22.39 15.3475 22.39 15.9775 22 16.3675L17.585 20.7824C17.195 21.1724 16.565 21.1724 16.175 20.7824L14 18.6074C13.61 18.2174 13.61 17.5875 14 17.1974C14.39 16.8074 15.02 16.8074 15.41 17.1974Z",
    fill: "#565A5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationSent);
export default __webpack_public_path__ + "static/media/icon-notification-sent.d31424f5a976a40a125c336966a71bca.svg";
export { ForwardRef as ReactComponent };